import { render, staticRenderFns } from "./SliderIcon.vue?vue&type=template&id=603c971c"
import script from "./SliderIcon.vue?vue&type=script&lang=ts"
export * from "./SliderIcon.vue?vue&type=script&lang=ts"
import style0 from "./SliderIcon.vue?vue&type=style&index=0&id=603c971c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports